import { render } from "./ShowQcConfiguration.vue?vue&type=template&id=2fc10458"
import script from "./ShowQcConfiguration.vue?vue&type=script&lang=js"
export * from "./ShowQcConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__